<template>
  <el-dialog
    :title="$t('다국어 사전')"
    :visible.sync="innerVisible"
    width="95%"
    :style="{ 'max-width': '900px' }"
    append-to-body>
    <div class="search_form" style="margin-bottom: 10px">
      <el-form :inline="true" label-width="60px" label-suffix=":" :size="size" @submit.native.prevent>
        <el-form-item :label="$t('언어')">
          <el-input v-model="searchText" @keyup.enter.native="searchDictionary" clearable style="width: 100%">
            <el-button slot="append" :size="size" @click="searchDictionary" icon="el-icon-search">{{
              $t('검색')
            }}</el-button>
          </el-input>
        </el-form-item>
      </el-form>
    </div>

    <el-table
      :height="350"
      border
      stripe
      highlight-current-row
      tooltip-effect="dark"
      :data="popTableData"
      :size="size"
      :empty-text="$t('언어 코드')">
      <el-table-column fixed>
        <template slot-scope="scope">
          <el-button :size="size" @click="selectDictionary(scope.row)">{{ $t('선택') }}</el-button>
        </template>
      </el-table-column>

      <el-table-column
        :label="$t('언어 코드')"
        prop="id"
        min-width="200"
        sortable
        show-overflow-tooltip></el-table-column>
      <el-table-column
        :key="item.id"
        v-for="item in lans"
        :label="item.nm"
        :prop="item.id"
        min-width="200"
        sortable
        show-overflow-tooltip></el-table-column>
    </el-table>
  </el-dialog>
</template>

<script>
import mainVueMixin from '@/mixins/mainVueMixin'

export default {
  mixins: [mainVueMixin],

  props: {
    visible: Boolean,
  },

  name: 'DictionaryDialog',

  data() {
    return {
      size: 'mini',
      popTableData: [],
      lans: [],
      searchText: '',
    }
  },

  computed: {
    innerVisible: {
      get() {
        return this.visible
      },
      set(val) {
        if (val === false) {
          this.$emit('close')
        }
      },
    },
  },

  mounted() {
    // this.initStore()
  },

  methods: {
    searchDictionary: function () {
      this.mainVue.$axios.search(
        '/dictionary/search',
        { nm: this.searchText, dictionaryTpVal: 'category' },
        function (result) {
          this.popTableData = []

          for (var i = 0, len = result.length; i < len; i++) {
            var tmp = result[i]

            tmp[result[i].lan.id] = result[i].nm

            for (var j = 0, jlen = result[i].dictionarys.length; j < jlen; j++) {
              tmp[result[i].dictionarys[j].lan.id] = result[i].dictionarys[j].nm
            }

            this.popTableData.push(tmp)
          }
        }.bind(this),
        true
      )
    },
    selectDictionary(row) {
      this.$emit('selectDictionary', row)
    },

    initStore: function () {
      this.mainVue.$axios.search(
        '/store/getStore',
        null,
        function (result) {
          this.storeLans = result.lans
          this.initStoreLans(result)
        }.bind(this)
      )
    },
    // 사전 조회를 위한 언어 정보 설정
    initStoreLans: function (store) {
      this.lans = []
      this.lans.push(store.defaultLan)

      for (var i = 0, len = store.lans.length; i < len; i++) {
        this.lans.push(store.lans[i])
      }
    },
  },
}
</script>
